import { AlertCircle, FileDown, Loader2 } from 'lucide-react';

import { EVAR_REPORT_VIEWPORT_ID } from './report/evar-report-views';

import { usePdfExport } from '@/components/report';
import { SnapshotPanelButton } from '@/components/snapshot/snapshot-panel';
import { Button } from '@/components/ui/button';

/**
 * Sidebar content for the "2 - Report" panel.
 * Shows the Export PDF button that triggers the PDF generation pipeline.
 */
export function EvarReportPanel() {
    const { exportPdf, exporting, error } = usePdfExport({
        viewportId: EVAR_REPORT_VIEWPORT_ID,
        fileNamePrefix: 'EVAR_Report',
    });

    return (
        <div className="flex flex-col gap-3 p-3">
            <p className="text-xs text-muted-foreground">Report preview is displayed in the main area.</p>
            <SnapshotPanelButton className="w-full" />
            <Button
                variant="outline"
                size="sm"
                className="w-full gap-2"
                disabled={exporting}
                onClick={exportPdf}
            >
                {exporting ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}
                {exporting ? 'Exporting...' : 'Export PDF'}
            </Button>
            {error && (
                <p className="flex items-center gap-1.5 text-xs text-destructive">
                    <AlertCircle className="h-3.5 w-3.5 shrink-0" />
                    {error}
                </p>
            )}
        </div>
    );
}
